import { Translate } from '@change-corgi/core-react/i18n';
import { Flex } from '@change-corgi/design-system-legacy/layout';
import { createModalHook } from '@change-corgi/design-system-legacy/modals';
import { Heading } from '@change-corgi/design-system-legacy/typography';

import type { StarterDashboardPageData } from '#src/app/pages/starterDashboard/pageContext';

import { DownloadFlyerModalBodyLoader as DownloadFlyerModalBody } from './components/DownloadFlyerModalBodyLoader';

type Context = 'starter_dashboard_task' | 'starter_dashboard_grow_petition';
type Petition = StarterDashboardPageData['petition'];

export const useDownloadFlyerModal = createModalHook<{ petition: Petition; context: Context }>({
	name: 'DownloadFlyerModal',
	heading: () => (
		<Flex mr={28}>
			<Heading breakWord as="h1" size="h3" data-qa="download-flyer-modal-heading">
				<Translate value="corgi.petition.starter_dashboard.shared.flyer.multi_modal_heading" />
			</Heading>
		</Flex>
	),
	body: function DownloadFlyerModal({ options: { petition, context } }) {
		return <DownloadFlyerModalBody petition={petition} context={context} />;
	},
	stylesOverrides: {
		width: 'calc(100% - 32px)',
		minWidth: [null, 600],
		maxWidth: [400, 640],
	},
});
